// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3PfSH","noInteraction":"EventWrapper_noInteraction__23GLX","pointerPassthrough":"EventWrapper_pointerPassthrough__24NDn"};